import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Box, Button, CircularProgress, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { CheckCircle, RadioButtonUnchecked } from '@material-ui/icons'

import { themeConWeb } from '@app/util/modernThemeConweb'
import { loadUserProgressStart } from '../../redux/modules/onboarding'
import DialogOnboarding from '../onboarding/DialogOnboarding'
import { getOnboardingPercentage } from '../onboarding/onboardingUtils'
import { pushSnowplow, toUserUnboardingProcessSchema } from '../../util/snowplow'
import { STARTED_ONBOARDING, VIEWED_ONBOARDING } from '../../util/events/onboardingEvents'

const useStyles = makeStyles({
  top: {
    position: 'absolute',
    left: 0,
    zIndex: 2,
  },
  bottom: {
    color: themeConWeb.color.greyShade1,
  },
  label: {
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    fontSize: '28px',
    fontWeight: 'bold',
  },
})

const ListItem = ({ text, done }) => {
  return (
    <Box component="li" display="flex" flexDirection="row" alignItems="center" marginY={3}>
      <Box marginRight={2} color={themeConWeb.color.brandPrimary} clone>
        {done ? <CheckCircle /> : <RadioButtonUnchecked />}
      </Box>
      <Typography>{text}</Typography>
    </Box>
  )
}

const HomeOnboarding = ({ defaultStep, hasEmailTime, hasCuisineTypes, hasMobileApp }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [showDialog, setShowDialog] = useState(false)

  useEffect(() => {
    pushSnowplow(toUserUnboardingProcessSchema(VIEWED_ONBOARDING, defaultStep.name))
  }, [defaultStep])

  const handleClickContinue = () => {
    setShowDialog(true)
    pushSnowplow(toUserUnboardingProcessSchema(STARTED_ONBOARDING, defaultStep.name))
  }

  const handleCloseDialog = () => {
    dispatch(loadUserProgressStart())
    setShowDialog(false)
  }

  const percentage = getOnboardingPercentage(hasEmailTime, hasCuisineTypes, hasMobileApp)
  return (
    <>
      <Box paddingRight={4}>
        <Box width="100%" textAlign="center" marginBottom={3}>
          {/* TODO Use the CircularProgress from the common folder here */}
          <Box position="relative" display="inline-flex">
            <CircularProgress
              className={classes.top}
              variant="static"
              value={percentage}
              thickness={5}
              size={115}
            />
            <CircularProgress
              className={classes.bottom}
              variant="determinate"
              value={100}
              thickness={5}
              size={115}
            />
            <Typography className={classes.label}>{percentage}%</Typography>
          </Box>
        </Box>
        <Typography variant="h6" gutterBottom>
          Complete Setup
        </Typography>
        <ul>
          <ListItem text="Create Foodsby account" done />
          <ListItem text="Set daily notification time" done={hasEmailTime} />
          <ListItem text="Pick favorite cuisines" done={hasCuisineTypes} />
          <ListItem text="Download mobile app" done={hasMobileApp} />
        </ul>
        <Box marginTop={4}>
          <Button variant="contained" fullWidth color="primary" onClick={handleClickContinue}>
            Continue
          </Button>
        </Box>
      </Box>
      {showDialog && <DialogOnboarding onClose={handleCloseDialog} />}
    </>
  )
}

export default HomeOnboarding
